export const GET_QUERYBUILDER_PROFILEGROUPS = "GET_QUERYBUILDER_PROFILEGROUPS"
export const GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS = "GET_QUERYBUILDER_PROFILEGROUPS_SUCCESS"
export const GET_QUERYBUILDER_PROFILEGROUPS_FAIL = "GET_QUERYBUILDER_PROFILEGROUPS_FAIL"

export const GET_QUERYBUILDER_PROFILES = "GET_QUERYBUILDER_PROFILES"
export const GET_QUERYBUILDER_PROFILES_SUCCESS = "GET_QUERYBUILDER_PROFILES_SUCCESS"
export const GET_QUERYBUILDER_PROFILES_FAIL = "GET_QUERYBUILDER_PROFILES_FAIL"

export const GET_QUERYBUILDER_PROFILEFILTERS = "GET_QUERYBUILDER_PROFILEFILTERS"
export const GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS = "GET_QUERYBUILDER_PROFILEFILTERS_SUCCESS"
export const GET_QUERYBUILDER_PROFILEFILTERS_FAIL = "GET_QUERYBUILDER_PROFILEFILTERS_FAIL"

export const QUERYBUILDER_API_ERROR = "API_ERROR"
